import useOrders from "api/useOrders";
import { getPublisherId } from "utils/publisher";
import { EToasterStatus, showToast } from "utils/showToast";

import Button from "components/Button/Button"
import { Modal } from "components/Modal"

export const RefundModal = ({ isOpen, onClose, currencySymbol, orderId, totalAmount }: { isOpen: boolean, onClose: () => void, currencySymbol: string, orderId: string, totalAmount: number }) => {
    const publisherId = getPublisherId();
    const { makeRefund, getOrderDetails } = useOrders(orderId, undefined, undefined, { selectedProjects: publisherId });

    const handleRefund = () => {
        makeRefund.mutate({ orderId, publisherId }, {
            onSuccess: () => {
                showToast({
                    message: 'Refund successful',
                    description: 'The refund has been initiated',
                    status: EToasterStatus.SUCCESS
                });
                getOrderDetails.refetch();
                onClose();
            }
        });

    }
    return (
        <Modal isOpen={isOpen} onClose={onClose} width={300} height={260}>
            <div className="flex flex-col gap-4 mt-2">
                <div className="font-semibold text-base-primary">Refund payment</div>
                <div className="text-base-secondary">
                    <div className="text-xs text-base-mutedForeground pb-4 border-b border-base-border">
                        Refunds take 5-10 days to appear on a customer's statement.
                    </div>
                    <div className="flex flex-col gap-1 mt-4">
                        <div className="text-xs text-base-mutedForeground">Refund amount:</div>
                        <div className="text-base-primary">{currencySymbol}{totalAmount}</div>
                    </div>

                    <div className="flex justify-end gap-2 mt-2">
                        <Button variant="text" onClick={onClose}>Cancel</Button>
                        <Button onClick={handleRefund}>Refund</Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}